<template>
    <div class="right-aside-wraper">
        <TopTabs :tabsObj="tabsObj" />
        <div class="pd-16 right-content" style="padding-top: 0px !important">
            <CustomElScrollbar class="c-scrollbar">
                <div class="mg-bottom-12 river-lake-island-project">
                    <div class="flex-align-center" v-for="item in topStatisticsList" :key="item.name">
                        <div class="statistics-label">{{ item.name }}</div>
                        <div class="statistics-value">{{ item.value }}</div>
                    </div>
                </div>
                <div class="mg-bottom-12">
                    <div class="flex-align-center static-title mg-bottom-16">
                        <i class="el-icon-caret-right icon-left" style="flex-shrink: 0"></i>
                        <span style="flex: 1">{{ $t('chengguan.index.rightAside.serviceDataStats') }}</span>
                    </div>
                    <div class="mg-bottom-8">
                        <DataStatistics class="c-statistics" :dataList="statisticList"
                            :currentIndex.sync="dataStatisticCurrenIndex" @change="getSubjectData()" />
                    </div>

                    <div>
                        <RankingProgress :dataList="serviceChartOption"></RankingProgress>
                    </div>
                </div>
                <div>
                    <div class="flex-align-center static-title mg-bottom-16">
                        <i class="el-icon-caret-right icon-left" style="flex-shrink: 0"></i>
                        <span style="flex: 1">{{
                            $t('chengguan.index.rightAside.suspectedEventStatusRatio')
                            }}</span>
                    </div>
                    <div style="height: 120px">
                        <BaseEchart ref="eventStatusChartRef" :chartOption="eventStatusChartOption" activePie>
                        </BaseEchart>
                    </div>
                </div>
                <div>
                    <div class="flex-align-center static-title mg-bottom-16">
                        <i class="el-icon-caret-right icon-left" style="flex-shrink: 0"></i>
                        <span style="flex: 1">{{
                            $t('chengguan.index.rightAside.suspectedEventTypeRatio')
                            }}</span>
                    </div>
                    <div>
                        <RankingProgress :dataList="eventTypeChartOption"></RankingProgress>
                    </div>
                </div>
            </CustomElScrollbar>
        </div>
    </div>
</template>
<script>
import TopTabs from '@/components/topTabs.vue';
import DataStatistics from '../../components/DataStatistics.vue';
import StatisticsCard from '../../components/StatisticsCard.vue';
import BaseEchart from '@/components/base-echart';
import RankingProgress from '../../components/RankingProgress.vue';
import CustomElScrollbar from '@/components/custom-el-scrollbar';
import DateUtil from '@/utils/DateUtil.js';
import DatepickerMixin from '@/mixins/datepicker.js';
import Api from '../../api';

const echartColor = ['#49F0FD', '#FD7C49', '#FDD349', '#49FD8B', '#FF1E1E', '#009DFF'];
export default {
    mixins: [DatepickerMixin],
    components: {
        TopTabs,
        DataStatistics,
        RankingProgress,
        BaseEchart,
        StatisticsCard,
        CustomElScrollbar,
    },
    props: {
        queryDate: {
            // 父组件通过传递这个函数去接收请求到的事件列表
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            tabsObj: {
                centre: this.$t('chengguan.index.rightAside.dataStats'),
                type: 3,
            },
            topStatisticsList: [],
            dataStatisticCurrenIndex: 0,
            statisticList: [
                {
                    name: this.$t('chengguan.index.rightAside.totalServiceDuration'),
                    value: '0',
                    unit: '',
                    url: 'icon-clock',
                    iconType: 'svg',
                    dataKey: 'serviceTotalTime',
                    dataItem: '0',
                },
                {
                    name: this.$t('chengguan.index.rightAside.totalServiceMileage'),
                    value: '0',
                    unit: 'km',
                    url: 'icon-route',
                    dataKey: 'serviceTotalMileage',
                    dataItem: '1',
                },
                {
                    name: this.$t('chengguan.index.rightAside.totalCollectedPhotos'),
                    value: '0',
                    unit: this.$t('chengguan.index.rightAside.pcs'),
                    url: 'icon-image',
                    dataKey: 'photoTotalCount',
                    dataItem: '2',
                },
                {
                    name: this.$t('chengguan.index.rightAside.totalCollectedVideos'),
                    value: '0',
                    unit: this.$t('chengguan.index.rightAside.units'),
                    url: 'icon-video',
                    dataKey: 'videoTotalCount',
                    dataItem: '3',
                },
            ],
            subjectData: [
                // { value: 12, name: '执法检查', unit: '小时' },
                // { value: 735, name: '取证', unit: '小时' },
                // { value: 580, name: '日常大范围巡 查/网格巡查', unit: '小时' },
                // { value: 484, name: '正射影像采集 与提示', unit: '小时' },
                // { value: 300, name: '工地违规情况 监督', unit: '小时' }
            ],
            eventStatusData: [
                // { value: 12, name: '待上报' },
                // { value: 70, name: '待办理' },
                // { value: 80, name: '已完成' },
            ],
            eventTypeData: [
                // { value: 12, name: '疑似违建', unit: '件' },
                // { value: 7, name: '占到经营', unit: '件' },
                // { value: 8, name: '偷倒建筑垃圾', unit: '件' },
                // { value: 4, name: '工地裸露黄土过多', unit: '件' },
                // { value: 30, name: '未按规定戴安全帽', unit: '件' }
            ],
        };
    },
    watch: {
        queryDate: {
            handler(newVal) {
                if (newVal.length > 0) {
                    this.doSearch();
                }
            },
            immediate: true,
            deep: true,
        },
    },
    computed: {
        pickerOptions() {
            return {
                ...this.mixinPickerOptions,
                onPick: ({ maxDate, minDate }) => {
                    // 当开始日期选中时，设置限制
                    if (minDate && !maxDate) {
                        const oneYearLater = new Date(minDate);
                        oneYearLater.setFullYear(oneYearLater.getFullYear() + 1);
                        this.maxSelectableDate = oneYearLater;
                    } else {
                        this.maxSelectableDate = null;
                    }
                },
                disabledDate: (time) => {
                    const [start, end] = this.dateRange || [];
                    if (start && !end) {
                        const startTime = new Date(start).getTime();
                        const maxTime = new Date(start);
                        maxTime.setFullYear(maxTime.getFullYear() + 1);
                        return time.getTime() > maxTime.getTime();
                    }
                    return false;
                },
            };
        },
        serviceChartOption() {
            let rawData = this.subjectData || [];
            // 计算 value 总和
            const totalValue = rawData.reduce((sum, item) => sum + item.value, 0);
            // 计算每项的百分比
            const resData = rawData.map((item) => ({
                ...item,
                percentage: totalValue === 0 ? 0 : parseFloat(((item.value / totalValue) * 100).toFixed(2)),
            }));
            // 按照 percentage 降序排序
            resData.sort((a, b) => b.percentage - a.percentage);
            return resData;
        },
        /**
         * 事件状态图表的配置项
         *
         * @returns {Object} 返回echarts图表的配置项对象
         */
        eventStatusChartOption() {
            let chartData = this.eventStatusData || [];

            // 计算 value 总和
            const totalValue = chartData.reduce((sum, item) => sum + item.value, 0);
            return {
                color: echartColor,
                title: [
                    {
                        show: true,
                        text: `${this.$t('chengguan.index.rightAside.total')}\n${totalValue}`,
                        textStyle: {
                            color: '#ffffff',
                            fontSize: 14,
                            lineHeight: 18,
                        },

                        textAlign: 'center',
                        bottom: 0,
                        top: 'center',
                        left: '28%',
                    },
                ],

                legend: {
                    top: '20%',
                    left: '50%',
                    orient: 'vertical',
                    textStyle: {
                        color: '#fff',
                        rich: {
                            val: {
                                color: '#49F0FD',
                            },
                        },
                    },
                    itemWidth: 6,
                    itemHeight: 6,

                    formatter(name) {
                        let data = chartData;
                        let val = '';
                        for (let i = 0; i < data.length; i++) {
                            if (data[i].name === name) {
                                val = data[i].value;
                            }
                        }
                        return `${name} {val|${val}}`;
                    },
                },
                series: [
                    {
                        type: 'pie',
                        radius: ['50%', '70%'],
                        center: ['30%', '50%'],
                        label: {
                            show: false,
                        },
                        data: chartData,
                    },
                ],
            };
        },

        eventTypeChartOption() {
            let rawData = this.eventTypeData || [];
            // 计算 value 总和
            const totalValue = rawData.reduce((sum, item) => sum + item.value, 0);
            // 计算每项的百分比
            const resData = rawData.map((item) => ({
                ...item,
                percentage: totalValue === 0 ? 0 : parseFloat(((item.value / totalValue) * 100).toFixed(2)),
            }));
            // 按照 percentage 降序排序
            resData.sort((a, b) => b.percentage - a.percentage);

            return resData;
        },
    },
    methods: {
        resizeChart() {
            if (this.$refs.eventStatusChartRef) {
                this.$refs.eventStatusChartRef.resize();
            }
        },
        doSearch() {
            this.getServiceData();
            this.getSubjectData();
            this.getEventStatusData();
            this.getEventTypeData();
            this.getWaterAreaStatistics();
        },
        // 获取河湖岛工程统计数据
        getWaterAreaStatistics() {
            let param = {
                beginTime: `${this.queryDate[0]} 00:00:00`,
                endTime: `${this.queryDate[1]} 23:59:59`,
            };
            Api.waterAreaStatistics(param).then((res) => {
                if (res.code === 200) {
                    let data = res.data || {};
                    this.topStatisticsList = [];
                    let statistics = [
                        { name: this.$t('hezhang.index.leftAside.river'), type: 'RIVER', value: 0 },
                        { name: this.$t('hezhang.index.leftAside.lakes'), type: 'LAKE', value: 0 },
                        { name: this.$t('hezhang.index.leftAside.island'), type: 'ISLAND', value: 0 },
                        { name: this.$t('hezhang.index.leftAside.project'), type: 'PROJECT_HZ', value: 0 },
                    ];

                    // 遍历data，将value对应到statistics中
                    data.forEach((item) => {
                        const matchedItem = statistics.find((stat) => stat.type === item.name);
                        if (matchedItem) {
                            matchedItem.value = Number(item.value);
                        }
                    });
                    this.topStatisticsList = statistics;
                }
            });
        },

        /**
         * 获取服务数据统计
         */
        getServiceData() {
            let param = {
                beginTime: this.queryDate[0],
                endTime: this.queryDate[1],
            };
            Api.fetchServiceStatistics(param).then((res) => {
                // console.log('fetchServiceStatistics', res);
                if (res.code === 200) {
                    let data = res.data || {};
                    this.statisticList.forEach((item) => {
                        item.value = data[item.dataKey] || 0;
                    });
                }
            });
        },
        /**
         * 获取服务统计数据
         */
        getSubjectData() {
            let param = {
                beginTime: this.queryDate[0],
                endTime: this.queryDate[1],
                dataItem: this.statisticList[this.dataStatisticCurrenIndex].dataItem,
            };
            Api.fetchSubjectStatistics(param).then((res) => {
                // console.log(res);
                if (res.code == 200) {
                    let list = res.data || [];
                    list.forEach((item) => {
                        item.value = item.count;
                    });
                    this.subjectData = list;
                }
            });
        },
        /**
         * 获取事件状态数据
         */
        getEventStatusData() {
            let param = {
                startTime: this.queryDate[0],
                endTime: this.queryDate[1],
            };
            Api.fetchEventStatusStatistics(param).then((res) => {
                if (res.code === 200) {
                    let list = res.data || [];
                    list.forEach((item) => {
                        item.value = item.count;
                    });
                    this.eventStatusData = list;
                }
            });
        },
        /**
         * 获取事件类型统计数据
         *
         * @returns {void}
         */
        getEventTypeData() {
            let param = {
                startTime: this.queryDate[0],
                endTime: this.queryDate[1],
            };
            Api.fetchEventTypeStatistics(param).then((res) => {
                if (res.code === 200) {
                    let list = res.data || [];
                    list.forEach((item) => {
                        item.value = item.count || item.eventCount;
                        if (item.eventTypeName) {
                            item.name = item.eventTypeName;
                        }
                    });
                    this.eventTypeData = list;
                }
            });
        },
    },
    created() { },
    mounted() { },
};
</script>
<style lang="scss" scoped>
$blueLight: #49f0fd;

.right-aside-wraper {
    height: 100%;
    overflow: hidden;

    .right-content {
        height: calc(100% - 40px);
        margin-right: -1px;

        .c-scrollbar {
            $searchHeight: 32px;
            height: calc(100% - #{$searchHeight});
        }

        .river-lake-island-project {
            display: flex;
            justify-content: space-between;
            height: 40px;
            border-bottom: 1px #49f0fd solid;

            .statistics-label {
                margin-right: 5px;
                min-width: 20px;
            }

            .statistics-value {
                color: #409eff;
                font-size: 14px;
                font-weight: bold;
            }
        }
    }

    .static-title {
        padding: 12px 8px;
        background: linear-gradient(-270deg, rgba(10, 167, 255, 0.22) 0%, rgba(10, 167, 255, 0) 100%);
        border-radius: 0px 0px 0px 0px;
        border: 1px solid;
        border-left: 0px;
        border-right: 0px;
        border-image: linear-gradient(34deg, rgba(73, 240, 253, 0.25), rgba(73, 240, 253, 0)) 1 1;

        .icon-left {
            color: #ef8200;
        }
    }

    .text-number {
        color: $blueLight;
    }

    .text-unit {
        color: #fff;
    }

    ::v-deep .c-statistics {
        position: relative;
        width: 100%;
        flex-wrap: wrap;

        .data-zitem {
            margin: 0px;
            width: calc(50% - 4px);
            margin-bottom: 8px;
        }
    }
}
</style>
